import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
//mport { useStaticQuery, graphql } from 'gatsby';
import cx from 'classnames';
import styles from './Footer.module.scss';
import { Column, FlexGrid, Row } from '@carbon/react';

const ZweiUnd40Logo = () => (
  <img src={require("/images/42_logo_small.png")} alt="zwei&40 GmbH" />
);

const MicastLogo = () => <img src={require("images/micast_logo_small.png")} alt="micast" />;

const DefaultContent = () => (
  <p>
    Shadow this content by importing the theme Footer and supplying your own
    props.
  </p>
);

const DEFAULT_LINKS = {
  firstCol: [
    { href: 'https://www.ibm.com/design', linkText: 'Sample' },
    { href: 'https://www.ibm.com/design', linkText: 'Links' },
    { href: 'https://www.ibm.com/design', linkText: 'Column' },
    { href: 'https://www.ibm.com/design', linkText: 'One' },
  ],
  secondCol: [
    { href: 'https://www.ibm.com/design', linkText: 'Dribbble' },
    { href: 'https://www.ibm.com/design', linkText: 'Medium' },
    { href: 'https://www.ibm.com/design', linkText: 'Twitter' },
  ],
};

const Footer = ({
  Content = DefaultContent,
  links = DEFAULT_LINKS,
  LeftContent,
  Logo: _Logo = ZweiUnd40Logo,
  showSideNav = false,
  minimizedSideNav = false,
}) => {
  const { firstCol, secondCol } = links;

  return (
    <footer className={cx([styles.footer, showSideNav && !minimizedSideNav ? styles.foot_with_side_nav : styles.footer_without_side_nav ])}>
      <FlexGrid>
        <Row>
          <Column lg={6} md={6}>
            <MicastLogo />
            <LeftContent />
            <div className={styles.listItem}>
              {secondCol &&
                secondCol.map((link, i) => (
                  <a
                    href={link.href}
                    aria-label={link.linkText}
                    key={`social_link_${i}`}>
                    {link.linkText}
                  </a>
                ))}
            </div>
          </Column>
          <Column>
            <ul className={styles.nav}>
              {firstCol &&
                firstCol.map((link, i) => (
                  <li key={i} className={styles.listItem}>
                    <a href={link.href} aria-label={link.linkText}>
                      {link.linkText}
                    </a>
                  </li>
                ))}
            </ul>
          </Column>

          <Column className={styles.content} lg={4} md={4}>
            <Content buildTime={20} />
          </Column>
        </Row>
      </FlexGrid>
    </footer>
  );
};

Footer.propTypes = {
  /**
   * Specify the first and second columns of your links
   */
  links: PropTypes.exact({
    firstCol: PropTypes.arrayOf(
      PropTypes.shape({
        href: PropTypes.string,
        linkText: PropTypes.oneOfType([ PropTypes.string, PropTypes.element]),
      })
    ),
    secondCol: PropTypes.arrayOf(
      PropTypes.shape({
        href: PropTypes.string,
        linkText: PropTypes.oneOfType([ PropTypes.string, PropTypes.element]),
      })
    ),
  }),

  /**
   * Specify the first and second columns of your links
   */
  Content: PropTypes.elementType,

  /**
   * Provide a logo to be rendered in the bottom left corner
   */
  Logo: PropTypes.elementType,
};

export default Footer;
